import { ButtonPrimary, TextL, TextM, TextS, TextXs } from 'app/components';
import {
  TableBodyCellContainer,
  TableHeadCellContainer,
} from 'app/styles/components/Table';
import { formatCurrency } from 'app/utils/normalizer';
import {
  PersonCreditLineStatusLabel,
  TPersonCreditLineStatus,
  TQualificationWithStatusAndProduct,
} from 'modules/customer/interfaces/qualifications';
import dayjs from 'dayjs';
import { EQualificationLabel } from 'modules/products/context/QualificationsProvider/qualifications.interfaces';

export const tableQualificationHeader = [
  {
    id: '5',
    content: (
      <TableHeadCellContainer style={{ textAlign: 'center' }}>
        <TextL weight="bold">Status</TextL>
      </TableHeadCellContainer>
    ),
  },
  {
    id: '1',
    content: (
      <TableHeadCellContainer>
        <TextL weight="bold">Válido até</TextL>
      </TableHeadCellContainer>
    ),
  },
  {
    id: '2',
    content: (
      <TableHeadCellContainer>
        <TextL weight="bold">Produto</TextL>
      </TableHeadCellContainer>
    ),
  },
  {
    id: '4',
    content: (
      <TableHeadCellContainer style={{ textAlign: 'center' }}>
        <TextL weight="bold">Limite total</TextL>
      </TableHeadCellContainer>
    ),
  },
  {
    id: '6',
    content: (
      <TableHeadCellContainer style={{ textAlign: 'center', width: '100%' }}>
        <TextL weight="bold">Ações</TextL>
      </TableHeadCellContainer>
    ),
  },
];

function getStatusLabel(
  qualification: TQualificationWithStatusAndProduct | null,
): string {
  if (!qualification?.status) return 'Não informado';
  const status = qualification.status as TPersonCreditLineStatus;
  if (status in PersonCreditLineStatusLabel) {
    return PersonCreditLineStatusLabel[status];
  }
  return (
    EQualificationLabel[
      qualification.status as keyof typeof EQualificationLabel
    ] || 'Não informado'
  );
}

function getValidUntilDisplay(
  qualification: TQualificationWithStatusAndProduct | null,
): string {
  const date =
    qualification?.valid_until ??
    qualification?.updated_at ??
    qualification?.created_at;
  if (!date) return 'Não informado';
  return dayjs(date).format('DD/MM/YYYY');
}

export const renderQualificationTableContent = (
  qualification: TQualificationWithStatusAndProduct | null,
  setSelectedQualification: (
    qualification?: TQualificationWithStatusAndProduct,
  ) => void,
) => {
  return [
    {
      id: '5',
      content: (
        <TableBodyCellContainer>
          <TextM>{getStatusLabel(qualification)}</TextM>
        </TableBodyCellContainer>
      ),
    },
    {
      id: '1',
      content: (
        <TableBodyCellContainer>
          <TextS>{getValidUntilDisplay(qualification)}</TextS>
        </TableBodyCellContainer>
      ),
    },
    {
      id: '2',
      content: (
        <TableBodyCellContainer>
          <TextS weight="Bold">{qualification?.product?.name}</TextS>
          <TextXs>{qualification?.product?.description}</TextXs>
        </TableBodyCellContainer>
      ),
    },
    {
      id: '4',
      content: (
        <TableBodyCellContainer>
          <TextS>
            {formatCurrency(
              qualification?.condition?.line_of_credit?.credit_limit || 0,
            )}
          </TextS>
        </TableBodyCellContainer>
      ),
    },
    {
      id: '6',
      content: (
        <TableBodyCellContainer
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginLeft: '0px',
          }}
        >
          <ButtonPrimary
            typeVariant="ghost"
            style={{ width: 'fit-content' }}
            onClick={() => setSelectedQualification(qualification || undefined)}
          >
            Acessar
          </ButtonPrimary>
        </TableBodyCellContainer>
      ),
    },
  ];
};
